import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "users-tabs mb-4" }
const _hoisted_2 = {
  role: "tablist",
  class: "nav nav-tabs",
  "aria-label": "Benutzerkonten Tabs"
}
const _hoisted_3 = ["aria-selected"]
const _hoisted_4 = ["aria-selected"]


export default {
  __name: 'UsersTabs',
  props: {
	activeTab: {
		type: String,
		required: true,
		validator: (value) => ["students", "employees"].includes(value),
	},
},
  emits: ["update:activeTab"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const setActiveTab = (tab) => {
	emit("update:activeTab", tab);
};

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        id: "students-tab",
        role: "tab",
        class: _normalizeClass(["nav-link", { active: __props.activeTab === 'students' }]),
        "aria-selected": __props.activeTab === 'students',
        "aria-controls": `students-panel`,
        onClick: _cache[0] || (_cache[0] = $event => (setActiveTab('students')))
      }, " Studenten ", 10 /* CLASS, PROPS */, _hoisted_3),
      _createElementVNode("button", {
        id: "employees-tab",
        role: "tab",
        class: _normalizeClass(["nav-link", { active: __props.activeTab === 'employees' }]),
        "aria-selected": __props.activeTab === 'employees',
        "aria-controls": `employees-panel`,
        onClick: _cache[1] || (_cache[1] = $event => (setActiveTab('employees')))
      }, " Mitarbeiter ", 10 /* CLASS, PROPS */, _hoisted_4)
    ])
  ]))
}
}

}